<template>
  <div class="inline">
    <a-button v-if="this.questionList.length > 0" type="link" @click="open">检测题查看</a-button>

    <a-modal :visible="visible" :width="1000" title="试卷预览" @ok="handleCancel" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleCancel">
          关闭
        </a-button>
      </template>

      <a-list item-layout="vertical" :data-source="questionList">

        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta>
            <div slot="title">
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'ANSWER'">问答题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'PREVIEW'">预习题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'JUDGMENT'">判断题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'COMPLETION'">填空题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VIDEO'">口述题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'SINGLE_CHOICE'">单选题
              </a-tag>
              <a-tag>
                {{ item.node_str }}
              </a-tag>
              <div v-html="item.title" />
            </div>
            <template slot="description">
              <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                <a-col :span="6" v-for="option in item.options" :key="option.value">
                  <div class="option">
                    <label class="label">{{ option.keys }}:</label>
                    <div class="span" v-html="option.value" />
                  </div>
                </a-col>
              </a-row>
              <div>
                <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                <span
                  v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                <span>{{ item.answer }}</span>
              </div>
            </template>
          </a-list-item-meta>
          <div>
            <a-rate :value="item.star"></a-rate>
            <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
            <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
            <a-divider v-if="item.previewvideo != ''" type="vertical"></a-divider>
            <template v-if="item.systag != 0">
              <a-tag color="#2db7f5">相似题</a-tag>
              <a-divider type="vertical" />
            </template>
            <!-- <or-preview v-if="item.previewvideo!=''" text="预习视频" :videoUrl="item.previewvideo" />
                        <or-preview v-if="item.analysisvideo!=''" text="解析视频" :videoUrl="item.analysisvideo" /> -->
          </div>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>


export default {
  props: {
    item: {
      type: Object,
      require: true
    },
    testpaper_id: undefined
  },
  data() {
    return {
      visible: false,
      questionList: []
    };
  },
  mounted() {
    this.show();
  },
  methods: {
    selectItem(id) {
      this.exam.type = id;
    },
    selectGradeItem(id) {
      this.exam.grade_id = id;
    },
    selectSemesterItem(id) {
      this.exam.semester_id = id;
    },

    show() {
      this.$axios
        .post("/api/QuestionProblems/getyxbangjc", {
          data: {
            testpaper_id: this.item.id,
            problems_id: this.item.id,
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.questionList = res.data;
            for (let i = 0; i < this.questionList.length; i++) {
              if (this.questionList[i]["tag"] != "") {
                this.questionList[i]["tag"] = this.questionList[i][
                  "tag"
                ].split(",");
              }
            }

          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    open() {
      this.visible = true;
      this.questionList = [];
      this.show()

    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    handleRemoveQuestion(item) {
      this.$emit("remove", item);
    }
  },

};
</script>

<style lang="less" scoped>
.inline {
  display: inline;
  margin-right: 1rem;
}

.option {
  display: flex;

  .label {
    font-weight: bold;
  }

  .span {
    width: 0;
    flex: 1;
    margin-left: 0.5rem;
  }
}
</style>